module.exports = __webpack_public_path__ + "img/hcmi_logo.9feb6cdf.png";